module.exports = __webpack_public_path__ + "media/images/copyIcon-0c6a59fa.png";